import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Images } from '@/assets';
import { colors } from '@/theme/colors';
import { langPath } from '@/utils/langPath';
import { useCallback } from 'react';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateToHome = useCallback(() => {
    navigate(langPath('/main'));
  }, [navigate]);

  return (
    <Container>
      <Wrapper>
        <ErrorImage src={Images.NotFoundImage} alt="icon-not-found" />
        <MainTitle>{t('thePageIsUnavailable')}</MainTitle>
        <SubTitle>
          {t('thePageYouAreLookingForDoesNotExistOrIsCurrentlyUnavailable')}
        </SubTitle>
        <SubTitle>{t('pleaseCheckTheAddressYouEnteredOnceAgain')}</SubTitle>
        {/* 홈 버튼 추가 예정 */}
        <HomeButton onClick={handleNavigateToHome}>{t('goToHome')}</HomeButton>
      </Wrapper>
    </Container>
  );
};

export default NotFound;

const Container = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MainTitle = styled.h1`
  font-size: 44px;
  font-weight: 700;
  color: ${colors.black};
  text-align: center;
`;

const SubTitle = styled.div``;

const ErrorImage = styled.img`
  max-width: 120px;
`;

const HomeButton = styled.button`
  margin-top: 40px;
  width: 200px;
  height: 50px;
  border-radius: 8px;
  background-color: ${colors.primaryBg};
  color: ${colors.white};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  &:active {
    border: none;
    outline: none;
  }
  &:focus {
    border: none;
    outline: none;
  }
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
`;
